export default () => !!window.navigator.maxTouchPoints || 'ontouchstart' in document;
